import { createContext, ReactNode } from "react";
import { SafetyDashboardDriverDto } from "../../../common/data/service-proxies";
import { WidgetProps } from "../../assets/maintenance-dashboard/common";

export type SelectedDriversFilter =
  | "WITH_UNRESOLVED_DVIR_DEFECTS"
  | "WITH_HARSH_EVENTS"
  | "WITH_HARSH_ACCELERATION"
  | "WITH_HARSH_BRAKING"
  | "WITH_MAJOR_UNRESOLVED_DVIR_DEFECTS"
  | "WITH_MINOR_UNRESOLVED_DVIR_DEFECTS"
  | "WITH_HARSH_TURNS"
  | "WITH_IMPACTS"
  | "WITH_SPEEDING_EVENTS"
  | "WITH_PHYSICAL_ELD_DISCONNECTIONS"
  | "WITH_SCORE_GOOD"
  | "WITH_SCORE_SATISFACTORY"
  | "WITH_SCORE_CRITICAL";

export const SelectedDriversFilterContext = createContext<
  SelectedDriversFilterAccessor | undefined
>(undefined);

export interface SelectedDriversFilterAccessor {
  selectedFilter?: SelectedDriversFilter;
  setSelectedFilter: (value?: SelectedDriversFilter) => void;
}

export interface DriverWidgetProps extends WidgetProps {
  driver: SafetyDashboardDriverDto;
  children?: ReactNode;
}
